import { template as template_fd9b2463e5f141cfb5666b64daa1f11a } from "@ember/template-compiler";
import optional from '@nullvoxpopuli/ember-composable-helpers/helpers/optional';
import BvChoiceBlocksInput from 'volta/components/bv-choice-blocks/input';
import BvIcon from 'volta/components/bv-icon';
import BvText from 'volta/components/bv-text';
import classNames from 'volta/helpers/class-names';
import orElse from 'volta/helpers/or-else';
import type { TOC } from '@ember/component/template-only';
import type { ContentValue } from '@glint/template';
import type { BvChoiceBlocksInputSignature } from 'volta/components/bv-choice-blocks/input';
import type { TSize } from 'volta/utils/style-utils';
import type { IChoiceItem } from '.';
import type { BvIconSignature } from './../bv-icon/index';
export interface BvChoiceBlocksBlockSignature {
    Args: BvChoiceBlocksInputSignature['Args'] & {
        item: IChoiceItem;
        description?: ContentValue;
        icon?: string;
        iconColor?: BvIconSignature['Args']['color'];
        inlineIcon?: boolean;
        size?: TSize;
        title?: string;
    };
    Element: HTMLDivElement;
    Blocks: {
        icon: [IChoiceItem, BvIconSignature['Args']['color'] | undefined];
    };
}
const BvChoiceBlocksBlockComponent: TOC<BvChoiceBlocksBlockSignature> = template_fd9b2463e5f141cfb5666b64daa1f11a(`
  <BvChoiceBlocksInput
    @disabled={{@disabled}}
    @checked={{@checked}}
    @onChange={{@onChange}}
    @onHover={{@onHover}}
    @onMouseEnter={{optional @onMouseEnter}}
    @onMouseLeave={{optional @onMouseLeave}}
    @testName='{{@item.value}}'
  >
    <div
      class={{classNames
        'bv-choice-block-item__content'
        (if @inlineIcon 'bv-choice-block-item__content--inline')
      }}
      ...attributes
    >
      {{#if (has-block 'icon')}}
        {{yield @item @iconColor to='icon'}}
      {{else if @item.icon}}
        <BvIcon
          class='bv-choice-block-item__icon'
          @glyph={{@item.icon}}
          @color={{@iconColor}}
          @size={{orElse @size 'lg'}}
        />
      {{/if}}
      <div class='bv-choice-block-item__titles'>
        <BvText
          @text={{@item.title}}
          class='bv-choice-block-item__title'
          aria-label={{@item.title}}
        />
        {{#if @item.description}}
          <BvText
            class='bv-choice-block-item__description'
            @text={{@item.description}}
            @color='subdued'
          />
        {{/if}}
      </div>
    </div>
  </BvChoiceBlocksInput>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
export default BvChoiceBlocksBlockComponent;
declare module '@glint/environment-ember-loose/registry' {
    export default interface Registry {
        'BvChoiceBlocks::Block': typeof BvChoiceBlocksBlockComponent;
        'bv-choice-blocks/block': typeof BvChoiceBlocksBlockComponent;
    }
}
